<div class="dialog">
  <div class="row">
    <div class="col-md-6">
      <h2 class="dialog-header">{{ modalTitle | translate }}</h2>
    </div>
    <div class="col-md-6 align-right">
      <button
        type="button"
        class="btn btn-xs btn-success"
        (click)="addCategory()"
        *ngIf="listMode && permissions.canCreate"
      >
        <i class="fa fa-plus"></i> {{ 'ADD_CATEGORY' | translate }}
      </button>
      <button type="button" class="btn btn-xs" (click)="showCategories()" *ngIf="detailMode">
        <i class="fa fa-angle-left"></i> {{ 'BACK' | translate }}
      </button>

      <span class="dialog-close" (click)="close()">
        <i class="fa fa-close"></i>
      </span>
    </div>
  </div>

  <div class="dialog-content">
    <div *ngIf="listMode">
      <div *ngIf="permissions.canList">
        <app-category-list
          [categories]="categories"
          [meta]="meta"
          [loadingCategories]="loadingCategories"
          [defaultLanguage]="defaultLanguage"
          (selectedCategory)="onSelectedCategory($event)"
        ></app-category-list>
      </div>
      <div *ngIf="!permissions.canList">INVALID ACCESS</div>
    </div>

    <div *ngIf="detailMode">
      <app-category-detail
        [category]="category"
        [mode]="mode"
        [defaultLanguage]="defaultLanguage"
        [additionalLanguages]="additionalLanguages"
        [isModal]="true"
        (savedCategory)="onSavedCategory($event)"
        (canceledCategory)="onCanceledCategory()"
      ></app-category-detail>
    </div>
  </div>
</div>
